
  const mySwiperProductGrid = new Swiper('.swiper-product-grid', {  
  loop: true,  
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  scrollbar: {
    el: '.swiper-scrollbar',    
  },
});

document.addEventListener("DOMContentLoaded", function () {
  const productTypeEl = document.querySelector('#Product-Type');
  if (!productTypeEl) return;

  const productType = productTypeEl.dataset.productType;
  if (productType !== "オリジナルラベル") return;

  const quantityInput = document.querySelector('#Product-Quantity');
  const plusButton = document.querySelector('button[name="plus"]');
  const minusButton = document.querySelector('button[name="minus"]');

  const step = 49;
  const min = 200;

  if (plusButton && minusButton && quantityInput) {
    plusButton.addEventListener('click', (e) => {
      e.preventDefault();
      const current = parseInt(quantityInput.value) || min;
      quantityInput.value = current + step;
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    });

    minusButton.addEventListener('click', (e) => {
      e.preventDefault();
      const current = parseInt(quantityInput.value) || min;
      if (current > min) {
        quantityInput.value = current - step;
        quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }
});
